import Role from 'enums/Role';
import User from 'interfaces/User';
import * as React from "react";

interface UserDataTableProps {
    data: User[],
    onCheckboxChanged: (e: React.FormEvent<HTMLInputElement>) => void;
    onDropdownChanged: (e: React.ChangeEvent<HTMLSelectElement>, index: number) => void;
}

export default function UserDataTable(props: UserDataTableProps) {
    const columns = props.data[0] && Object.keys(props.data[0]);
    return <div className="table-container"><table cellPadding={0} cellSpacing={0} className="table">
        <thead>
            <tr>
                <th></th>
                <th>Username</th>
                <th>Name</th>
                <th>Initials</th>
                <th>Email</th>
                <th>Role</th>
            </tr>
        </thead>
        <tbody>
            {props.data.map((item, index) =>
                <tr key={item.username}>
                    <td><input type="checkbox" value={index} onChange={props.onCheckboxChanged} /></td>
                    <td>{item.username}</td>
                    <td>{item.name}</td>
                    <td>{item.initials}</td>
                    <td>{item.email}</td>
                    <td>
                        <select name="roleId" value={item.roleId} className="form-control select2-single" onChange={(e) => props.onDropdownChanged(e, index)} title="">
                            <option value={Role.Admin}>Admin</option>
                            <option value={Role.Support}>Support</option>
                            <option value={Role.Sales}>Sales</option>
                        </select>
                    </td>
                </tr>
            )}
        </tbody>
    </table></div>
}


// WEBPACK FOOTER //
// ./ClientApp/components/common/UserDataTable.tsx